import { HEADER_NAVIGATION_ITEMS } from './navigationItems';

export const getHeaderNavigationItems = ashlinkUserRedirections =>
	HEADER_NAVIGATION_ITEMS.map(navigationItem => {
		const navigationItemWithRedirects = { ...navigationItem };

		let matchingRedirections = ashlinkUserRedirections.filter(
			redirection => redirection.pageKey === navigationItem.key
		);
		if (matchingRedirections.length > 0) {
			navigationItemWithRedirects.isLegacy = true;
			navigationItemWithRedirects.path =
				matchingRedirections[0].redirectUrl;
		}
		if (navigationItem.isDropdown) {
			navigationItemWithRedirects.menuItems =
				navigationItem.menuItems.map(menuItem => {
					const menuItemWithRedirects = { ...menuItem };
					matchingRedirections = ashlinkUserRedirections.filter(
						redirection => redirection.pageKey === menuItem.key
					);
					if (matchingRedirections.length > 0) {
						menuItemWithRedirects.isLegacy = true;
						menuItemWithRedirects.path =
							matchingRedirections[0].redirectUrl;
					}
					return menuItemWithRedirects;
				});
		}
		return navigationItemWithRedirects;
	});

export const getHomePagePath = ashlinkUserRedirections => {
	const homePath = getHeaderNavigationItems(ashlinkUserRedirections).filter(
		item => item.key === 'home'
	)[0]?.path;
	return homePath;
};
